import React from "react";
import PropTypes from "prop-types";

import Size from "components/Size";
import { objectValueNotZero } from "utils";

import styles from "./SpaceSize.css";

const Capacity = ({ capacity, isUnitBlack, isValueBold }) => (
  <div className={styles.root}>
    {objectValueNotZero(capacity) && (
      <Size
        isUnitBlack={isUnitBlack}
        isValueBold={isValueBold}
        unit={capacity.unit}
        value={capacity.value}
      />
    )}
  </div>
);

Capacity.propTypes = {
  capacity: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  isUnitBlack: PropTypes.bool,
  isValueBold: PropTypes.bool,
};

export default Capacity;
